import { render, staticRenderFns } from "./AtomTrashButton.vue?vue&type=template&id=38197cbb&"
import script from "./AtomTrashButton.vue?vue&type=script&lang=js&"
export * from "./AtomTrashButton.vue?vue&type=script&lang=js&"
import style0 from "./AtomTrashButton.vue?vue&type=style&index=0&id=38197cbb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports